import React from "react";

const AgentPayments = () => {
    const payments = [
        {
            date: "14/10/25 & 10:30 AM",
            package: "Gold",
            transactionId: "pay_hE6yQj3V3Jg7d1",
            amount: "1000",
            method: "GPAY",
            status: "Success",
        },
        {
            date: "25/07/25 $ 02:15 PM",
            package: "Gold",
            transactionId: "pay_hE6yQj3V3Jf2d5",
            amount: "1000",
            method: "Card",
            status: "Failed",
        },
        {
            date: "22/06/25 & 11:00 AM",
            package: "Silver",
            transactionId: "pay_hE6yQj3V3Jgk8f",
            amount: "500",
            method: "GPAY",
            status: "Success",
        },
    ];

    return (
        <>
            <div className="agent-payment-container">
                <h2 class="font-great-vibes" style={{ margin: '0px 20px 20px', color: '#B21919', }}>
                    Payment History
                </h2>

                <table className="payment-table">
                    <thead>
                        <tr>
                            <th>Date & Time</th>
                            <th>Transaction ID</th>
                            <th>Subscription Package</th>
                            <th>Payment Method</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payments.map((item, index) => (
                            <tr key={index}>
                                <td>{item.date}</td>
                                <td>{item.transactionId}</td>
                                <td>
                                    {item.package}
                                    {/* <div className="package-amount">{item.amount}</div> */}
                                </td>
                                <td>{item.method}</td>
                                <td>{item.amount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <style jsx>
                {`
                    .agent-payment-container {
                        background: #FFECD6;
                        padding: 25px;
                        border-radius: 12px;
                        box-shadow: 0px 2px 8px rgba(0,0,0,0.08);
                        margin-right: 20px;
                        margin-bottom: 20px;
                    }

                    .payment-table {
                        width: 100%;
                        border-collapse: separate;
                        border-spacing: 0 10px;
                        margin-top: 15px;
                        font-size: 18px;
                        overflow: hidden;
                        border-radius: 10px; 
                    }

                    .payment-table thead tr th:first-child {
                        border-top-left-radius: 10px;
                        border-bottom-left-radius: 10px;
                    }

                    .payment-table thead tr th:last-child {
                        border-top-right-radius: 10px;
                        border-bottom-right-radius: 10px;
                    }

                    .payment-table th {
                        text-align: center;
                        padding: 12px;
                        background: #B21919;
                        border-bottom: 1px solid #eee;
                        color: white;
                        font-size: 20px;
                    }

                    .payment-table td {
                        padding: 14px 12px;
                        border-bottom: 1px solid #f1f1f1;
                    }

                    .package-amount {
                        font-size: 14px;
                        color: #666;
                    }

                    .status-badge {
                        padding: 4px 10px;
                        font-size: 14px;
                        border-radius: 12px;
                        display: inline-block;
                        font-weight: 600;
                    }

                    .status-badge.success {
                        background: #e8f8ee;
                        color: #1fa750;
                    }

                    .status-badge.failed {
                        background: #fdeaea;
                        color: #d9534f;
                    }
                `}
            </style>

        </>
    );
};

export default AgentPayments;
